var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClass1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6717_7295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.38427 18C8.24395 18 8.17455 17.8296 8.27495 17.7316L13.4955 12.6344C13.5421 12.5914 13.568 12.5346 13.568 12.4756C13.568 12.4165 13.5421 12.3597 13.4955 12.3167L8.27799 7.26895C8.1769 7.17114 8.24613 7 8.3868 7H10.9732C11.0133 7.0011 11.0527 7.00924 11.089 7.02395C11.1254 7.03866 11.1579 7.05962 11.1846 7.08556L16.5955 12.3167C16.6412 12.3577 16.6667 12.4124 16.6667 12.4694C16.6667 12.5264 16.6412 12.5812 16.5955 12.6222L11.1846 17.8656C11.1645 17.9011 11.1348 17.932 11.098 17.9554C11.0612 17.9788 11.0184 17.9941 10.9732 18H8.38427Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6717_7295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.88333,
    height: 11,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClass1);
export default __webpack_public_path__ + "static/media/class-1.716aeefee923a9b5b0f64563282d66da.svg";
export { ForwardRef as ReactComponent };